// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".color-blocks[data-v-f6049084]{text-align:center}.color-blocks__grid[data-v-f6049084]{grid-gap:1rem;display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));padding-bottom:4rem;padding-top:2.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
